import React, { Component, createRef } from 'react';
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import { axiosGet, axiosPost } from "../../../react_axios/Axios"
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import { getSponsershipDetails_action, insertSponsorshipInterest_action } from "../../../actions/exhibitor_module_actions/sponsorship_action/sponsorship_action"
import { connect } from "react-redux";
import { data } from "jquery";
import {
    cityActionId, countryActionId, primaryChapterListActionId, pincodeActionId, stateActionId, toastError, toastSuccess, stallTypeActionId, stallSizeActionId, GSTvalidationActionId, openSideListActionId, internationalAreaSlabActionId,
    lengthActionId, BASE_URL, link_BASE_URL, fetchAuthReport, DOC_BASE_URL,
    breadthActionId, downloadReport,
} from "../../../utils/constants";
import { fill_action } from "../../../actions/fillCombo_action"
import { gstNoValidator, panNoValidator, tanNoValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import Resizer from "react-image-file-resizer";
import {
    deleteChapterDoc_action
} from '../../../actions/primary_chapter_action'
import {
    primaryChapterAdd_action, getPreviewDetails_action, getDoubleStoreySSI_action, deleteSSicertificate_action, deleteTMMAITAMMA_action
} from '../../../actions/primary_chapter_action'
import moment from "moment";
import ConfirmationModal from "../../../common_components/confirmationa_modal";
import { insertUserRegistration_action, getExhibitionSSRCountryMappingData_action } from '../../../actions/user_registration_action';
import "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";

class Sponsorship extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States    
        this.state = {
            isLoading: false,
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            sponsorshipList: [],
            interestedPop: false,
            SSHdrId: '',
            additionalNote: '',
            name: '',
            companyName: '',
            mobile: '',
            email: '',
            country: '',
            city: '',
            type: '',
            from: '',
            intererestMode: '',
            isAgreePop: false,
            id: '',
            guidelines: ['The last date for confirming sponsorship participation and submitting all related branding and promotional materials is 30-09-2026.',
                'India ITME Society reserves the right, at its sole discretion, to make reasonable modifications to sponsorship benefits, branding placements, or deliverables, without materially affecting the overall value of the sponsorship.',
                'Any customization in the sponsorship package may incur additional costs and will be subject to availability.',
                'GST will be applicable as per Government rules.',
                'All display sites and structures are the sole property of India ITME Society.',
                'All sponsorship creatives must be submitted in CDR, EPS, or TIFF format via email.',
                'Sponsorship opportunities shall be allocated on a first-come, first-served basis, and will be confirmed only upon receipt of 100% advance payment.',
                'All submitted artwork, designs, text, maps, or other promotional content must comply with the ethics, rules, and values of India ITME Society and must not be politically sensitive. India ITME Society reserves the right to approve, modify, reject, or remove any sponsorship creatives and material that it deems misleading, defamatory, unlawful, politically sensitive, or otherwise inconsistent with the event’s standards and presentation.',
                'Ready to print files in the mentioned sizes shall be given in PDF / Corel Draw format 15 days prior to the exhibition.'
            ],
            isForceOpen: false
        }
        this.pdfRefs = [];
        this.pdfContainerRef = createRef();
        this.pdfContainerRef2 = createRef();
        this.getSponsershipDetails = this.getSponsershipDetails.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
        this.getDocName = this.getDocName.bind(this)
        this.insertInterested = this.insertInterested.bind(this)
        this.checkFileExt = this.checkFileExt.bind(this)
        this.openPdf = this.openPdf.bind(this)
    }
    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                // this.editSpaceBooking()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    componentDidMount() {
        console.log(this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.from != "", this.props.location.state.from, ' this.props.location.state.from')
        // this.setState({isLoad1stTime:false})
        this.setState({
            from:
                this.props.location.state != null &&
                    this.props.location.state != "" &&
                    this.props.location.state.from != "" && this.props.location.state.from != undefined
                    ? 1
                    : 2,
        });
        this.getSponsershipDetails()
        if (this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.from != "" && this.props.location.state.from != undefined) {
            this.setState({
                name: JSON.parse(sessionStorage.getItem('loginDataSS')).FirstName,
                companyName: (sessionStorage.getItem('visitorCompany')),
                mobile: (sessionStorage.getItem('visitorMobileNo')),
                email: (sessionStorage.getItem('visitorEmail')),
                country: JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName,
                city: (sessionStorage.getItem('visitorCity'))
            })
        } else {
            this.setState({
                name: JSON.parse(sessionStorage.getItem('loginDataSS')).FirstName,
                companyName: JSON.parse(sessionStorage.getItem('loginDataSS')).CompanyName,
                mobile: JSON.parse(sessionStorage.getItem('loginDataSS')).MobileNo,
                email: (sessionStorage.getItem('userEmailSS')),
                country: JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName,
                city: JSON.parse(sessionStorage.getItem('loginDataSS')).City
            })
        }
    }

    async PdfRender(pdfPath, container) {

        if (!pdfPath || !container) return;

        container.innerHTML = "";

        const url = `${DOC_BASE_URL}${pdfPath}`;
        console.log(url, container)

        try {

            const pdf = await pdfjsLib.getDocument(url).promise;

            for (let i = 1; i <= pdf.numPages; i++) {

                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;

                canvas.style.width = "100%";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);

                await page.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise;
            }

        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }


    getSponsershipDetails() {
        this.setState({ isLoading: true })
        this.props.getSponsershipDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        var sponsorshipList = [
                            {
                                "SponsorshipHdrID": 1,
                                "ExhibitionID": 3,
                                "SponsorshipTypeID": 1,
                                "SponsorshipTypeName": "Platinum",
                                "TotalQty": 1,
                                "AvailableQty": 0,
                                "AmountINR": 50000.00,
                                "AmountUSD": null,
                                "IsDeliverableAsPDF": true,
                                "DeliverablePdfPath": "https://www.rd.usda.gov/sites/default/files/pdf-sample_0.pdf",
                                "IsDeliverableCommonPdf": false,
                                "DeliverableCommonPdfPath": null,
                                "IsShowToExhibitor": true,
                                "IsShowToVisitor": true,
                                "SponsorshipStatusID": 2,
                                "SponsorshipStatusName": "Sold"
                            },
                            {
                                "SponsorshipHdrID": 2,
                                "ExhibitionID": 3,
                                "SponsorshipTypeID": 2,
                                "SponsorshipTypeName": "Gold",
                                "TotalQty": 3,
                                "AvailableQty": 2,
                                "AmountINR": 40000.00,
                                "AmountUSD": null,
                                "IsDeliverableAsPDF": false,
                                "DeliverablePdfPath": null,
                                "IsDeliverableCommonPdf": true,
                                "DeliverableCommonPdfPath": "/document/Sponsorship/CommonDeliverableDoc/Gold-2.pdf",
                                "IsShowToExhibitor": true,
                                "IsShowToVisitor": true,
                                "SponsorshipStatusID": 1,
                                "SponsorshipStatusName": "Available"
                            },
                            {
                                "SponsorshipHdrID": 3,
                                "ExhibitionID": 3,
                                "SponsorshipTypeID": 3,
                                "SponsorshipTypeName": "Silver",
                                "TotalQty": 2,
                                "AvailableQty": 1,
                                "AmountINR": 30000.00,
                                "AmountUSD": null,
                                "IsDeliverableAsPDF": false,
                                "DeliverablePdfPath": null,
                                "IsDeliverableCommonPdf": false,
                                "DeliverableCommonPdfPath": null,
                                "IsShowToExhibitor": true,
                                "IsShowToVisitor": true,
                                "SponsorshipStatusID": 1,
                                "SponsorshipStatusName": "Available"
                            },
                            {
                                "SponsorshipHdrID": 4,
                                "ExhibitionID": 3,
                                "SponsorshipTypeID": 4,
                                "SponsorshipTypeName": "Bronze",
                                "TotalQty": 4,
                                "AvailableQty": 4,
                                "AmountINR": 20000.00,
                                "AmountUSD": null,
                                "IsDeliverableAsPDF": false,
                                "DeliverablePdfPath": null,
                                "IsDeliverableCommonPdf": false,
                                "DeliverableCommonPdfPath": null,
                                "IsShowToExhibitor": true,
                                "IsShowToVisitor": true,
                                "SponsorshipStatusID": 1,
                                "SponsorshipStatusName": "Available"
                            }
                        ]
                        var list = [
                            {
                                "SponsorshipDtlID": 1,
                                "SponsorshipHdrID": 2,
                                "DeliverableName": "Item 1",
                                "DeliverablePDFDoc": null
                            },
                            {
                                "SponsorshipDtlID": 2,
                                "SponsorshipHdrID": 2,
                                "DeliverableName": "Item 2",
                                "DeliverablePDFDoc": null
                            },
                            {
                                "SponsorshipDtlID": 3,
                                "SponsorshipHdrID": 2,
                                "DeliverableName": "Item 3",
                                "DeliverablePDFDoc": null
                            },
                            {
                                "SponsorshipDtlID": 4,
                                "SponsorshipHdrID": 2,
                                "DeliverableName": "Item 4",
                                "DeliverablePDFDoc": null
                            },
                            {
                                "SponsorshipDtlID": 5,
                                "SponsorshipHdrID": 2,
                                "DeliverableName": "Item 5",
                                "DeliverablePDFDoc": null
                            },
                            {
                                "SponsorshipDtlID": 6,
                                "SponsorshipHdrID": 3,
                                "DeliverableName": "Item 1",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Silver-6.pdf"
                            },
                            {
                                "SponsorshipDtlID": 7,
                                "SponsorshipHdrID": 3,
                                "DeliverableName": "Item 2",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Silver-7.pdf"
                            },
                            {
                                "SponsorshipDtlID": 8,
                                "SponsorshipHdrID": 3,
                                "DeliverableName": "Item 3",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Silver-8.pdf"
                            },
                            {
                                "SponsorshipDtlID": 9,
                                "SponsorshipHdrID": 3,
                                "DeliverableName": "Item 4",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Silver-9.pdf"
                            },
                            {
                                "SponsorshipDtlID": 10,
                                "SponsorshipHdrID": 4,
                                "DeliverableName": "Item 1",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Bronze-10.pdf"
                            },
                            {
                                "SponsorshipDtlID": 11,
                                "SponsorshipHdrID": 4,
                                "DeliverableName": "Item 2",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Bronze-11.pdf"
                            },
                            {
                                "SponsorshipDtlID": 12,
                                "SponsorshipHdrID": 4,
                                "DeliverableName": "Item 3",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Bronze-12.pdf"
                            },
                            {
                                "SponsorshipDtlID": 13,
                                "SponsorshipHdrID": 4,
                                "DeliverableName": "Item 4",
                                "DeliverablePDFDoc": "/document/Sponsorship/DeliverableDocs/Bronze-13.pdf"
                            }
                        ]
                        data.data[0].length > 0 && data.data[0].map(item => {
                            item.isAgree = false
                            // sponsorshipList.length > 0 && sponsorshipList.map(item => {
                            var arr = []
                            data.data[1].length > 0 && data.data[1].map(item2 => {
                                // list.length > 0 && list.map(item2 => {
                                if (item2.SponsorshipHdrID == item.SponsorshipHdrID) {
                                    arr.push(item2)
                                }
                            })
                            item.deliverablesList = arr
                        })
                        setTimeout(() => {
                            this.setState({
                                sponsorshipList: data.data[0],
                                // sponsorshipList: sponsorshipList,
                                isLoading: false
                            });
                        }, 100);
                    }
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.sponsorshipList !== this.state.sponsorshipList) {
            this.state.sponsorshipList.forEach((item, index) => {
                console.log(item.DeliverablePdfPath, item.DeliverableCommonPdfPath, this.pdfRefs[index], '......')
                if (item.IsDeliverableAsPDF && this.pdfRefs[index]) {
                    this.PdfRender(item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? item.DeliverablePdfPath : '/document/Sponsorship/CommonDoc/Booked.jpg', this.pdfRefs[index]);
                } else if (item.IsDeliverableCommonPdf && this.pdfRefs[index]) {
                    this.PdfRender(item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? item.DeliverableCommonPdfPath : '/document/Sponsorship/CommonDoc/Booked.jpg', this.pdfRefs[index]);
                }
            });
        }
    }

    async PdfRender2() {
        // const { RandRpath } = this.state;
        // // console.log("RandRpath--------------------------------------------->", RandRpath)
        // if (!RandRpath) return;

        // const container = this.pdfContainerRef.current;
        // // console.log("container--------------------------------------------->", container)
        // if (!container) return;

        // container.innerHTML = ""; // clear old pages

        // const url = `${BASE_URL.split("/api")[0]}${RandRpath}`;
        // console.log("url--------------------------------------------->", url)
        // try {
        //     const pdf = await pdfjsLib.getDocument(url).promise;
        //     for (let i = 1; i <= pdf.numPages; i++) {
        //         const page = await pdf.getPage(i);
        //         const viewport = page.getViewport({ scale: 1.5 });

        //         const canvas = document.createElement("canvas");
        //         const context = canvas.getContext("2d");

        //         canvas.height = viewport.height;
        //         canvas.width = viewport.width;
        //         canvas.style.width = "100%";
        //         canvas.style.height = "auto";
        //         canvas.style.display = "block";
        //         canvas.style.margin = "20px auto";

        //         container.appendChild(canvas);
        //         await page.render({ canvasContext: context, viewport }).promise;
        //     }
        // } catch (err) {
        //     console.error("PDF rendering error:", err);
        // }
    }

    getDocName(filepath) {
        // var filepath = data.data[2][0]['PhotoID']
        var array = filepath.split("/")
        const FileName = array[array.length - 1]
        return FileName
    }

    checkFileExt(filepath) {
        var array = filepath.split("/")
        const FileName = array[array.length - 1]
        const extArr = FileName.split(".")
        const ext = extArr[extArr.length - 1]
        return ext
    }

    insertInterested() {
        const { Remark, Is_Agree, intererestMode, IsIntrested, SSHdrId, additionalNote } = this.state
        // this.inputValidate()
        // if (Is_Agree) {
        //     const ManualFormsID = this.props.location.state?.ManualFormsID || null;
        //     const ServiceID = this.props.location.state?.ServiceID || null;
        //     const VendorDetails = this.props.location.state?.VendorDetails || {};
        var mailData = {
            'UserId': '',
            'ExhibitionID': '',
            'ExhRegistrationID': '',
            'ExhVisitorID': '',
            'PersonName': this.state.name,
            'CompanyName': this.state.companyName,
            'Email': this.state.email,
            'MobileNo': this.state.mobile,
            'country': this.state.country,
            'city': this.state.city,
            'additionalNote': this.state.additionalNote,
            'ExhibitionName': sessionStorage.getItem("ExhibitionName"),
            'type': this.state.type
        }
        if (intererestMode == 2) {
            if (additionalNote.trim() == '') {
                toastError("Please Enter your customization requirements")
                return
            }
        }
        this.setState({ isLoading: true })
        this.props
            .insertSponsorshipInterest_action(SSHdrId, 1, additionalNote, mailData)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, interestedPop: false });
                    toastSuccess(
                        "Submitted successfully"
                    );
                    setTimeout(() => {
                        this.state.from == 1 ? this.props.navigate("/visitordashboard") : this.props.navigate("/manualForms");
                    }, 2000);
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    openPdf = (path) => {
        if (path) {
            window.open(path, "_blank");
        }
    };

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    render() {
        const { isLoading, isOpenConfirmationModal, sponsorshipList, name,
            companyName, from, isForceOpen,
            mobile, isAgreePop,
            email, SSHdrId,
            country, guidelines,
            city } = this.state
        console.log('///////////////dueDate', SSHdrId)
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        // console.log(area, InternationalArea, lev2, subChapters)
        var showMandatoryMark = false
        // showMandatoryMark = subChapters.length > 0 && subChapters.some(item => item.isMachine)
        console.log(sponsorshipList)
        return (
            <>
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {from == 1 ? <VisitorHeader2 /> : from == 2 ? <ExhibitorHeader /> : <></>}
                {from == 1 ? <VisitorDrawer /> : from == 2 ? <ExhibitorDrawer /> : <></>}
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container" >
                            <div style={{ marginTop: from == 1 ? '20px' : '0px' }}>
                                {/* <div className="container-fluid">
                                        <div className="row">
                                            <div className="tab-scroll-fixed">
                                        <p>Exhibitor Dashboard</p>
                                    </div>
                                            <ExhibitorTopMenu />
                                        </div>
                                    </div> */}
                                <div className=" width-dr-nav">
                                    <div className="row">
                                        {from == 1 ? <VisitorTopMenu /> : from == 2 ? <ExhibitorTopMenu /> : <></>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card rounded-0 border shadow-none">
                                            {/* <div className="card-header p-2">
                                            <h3 className="card-title"> Manual Forms</h3>
                                        </div> */}
                                            <div className="card-body p-2">
                                                <div className="row">
                                                    <div className="container pb-5" style={{ position: "relative" }}>
                                                        <div className={from == 1 ? "row mt-2" : 'row mt-5'}>
                                                            {sponsorshipList.length > 0 ? (
                                                                sponsorshipList.map((item, i) => (
                                                                    <div className="col-md-4 mt-2" key={i}>
                                                                        <div className="custom-card h-100 d-flex flex-column">
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <span className="badge cir-color rounded-circle p-2">
                                                                                    {String(i + 1).padStart(2, "0")}
                                                                                </span>
                                                                                {/* <span
                                                                                className={
                                                                                    item.Status == "Approved"
                                                                                        ? "status-badge-notfilled"
                                                                                        : item.Status == "Disapproved"
                                                                                            ? "status-badge-notfilled"
                                                                                            : item.Status == "Not Filled"
                                                                                                ? "status-badge-notfilled"
                                                                                                : item.Status == "Applied"
                                                                                                    ? "status-badge-notfilled"
                                                                                                    : ""
                                                                                }
                                                                            >
                                                                                {item.Status.toUpperCase()}
                                                                            </span> */}
                                                                            </div>

                                                                            <p className="text-muted fw-600 mb-2 py-1 rounded-1 text-dark" style={{ fontSize: '1.15rem' }}>
                                                                                Type of Sponsorship:  <strong className="fw-600">{item.SponsorshipTypeName}</strong>
                                                                            </p>
                                                                            {/* <br /> */}
                                                                            {/* <div
                                                                            className="d-flex align-items-center text-muted mb-1"
                                                                            style={{ justifyContent: "space-between" }}
                                                                        > */}
                                                                            <div className="row" style={{ textAlign: 'left' }}>
                                                                                {/* <span> */}
                                                                                <span className="dedline-text" style={{ fontSize: '1rem' }}>
                                                                                    Total Quantity: {" "}
                                                                                    <strong className="fw-600">
                                                                                        {item.TotalQty}
                                                                                    </strong>
                                                                                </span>
                                                                                {/* </span> */}
                                                                            </div>
                                                                            <div className="row" style={{ textAlign: 'left' }}>
                                                                                {/* <span> */}
                                                                                <span className="dedline-text" style={{ fontSize: '1rem' }}>
                                                                                    Available Quantity: {" "}
                                                                                    <strong className="fw-600">
                                                                                        {item.SponsorshipStatusID == 1 ? item.AvailableQty : 0}
                                                                                    </strong>
                                                                                </span>
                                                                                {/* </span> */}
                                                                            </div>
                                                                            <div className="row" style={{ textAlign: 'left' }}>
                                                                                {/* <span> */}
                                                                                <span className="dedline-text" style={{ fontSize: '1rem' }}>
                                                                                    {JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? 'Amount(INR)' : 'Amount(USD)'} : {" "}
                                                                                    <strong className="fw-600">
                                                                                        {JSON.parse(sessionStorage.getItem("loginDataSS")).CountryID == 91 ? item.AmountINR != null && item.AmountINR != '' ? item.AmountINR.toLocaleString(
                                                                                            "en-IN"
                                                                                        ) : 0 : item.AmountUSD != null && item.AmountUSD != '' ? item.AmountUSD.toLocaleString(
                                                                                            "en-IN"
                                                                                        ) : 0}
                                                                                    </strong>
                                                                                </span>
                                                                                {/* </span> */}
                                                                            </div>
                                                                            {/* <br /> */}
                                                                            {i == 3 && console.log(item.SponsorshipStatusID == 1, item.AvailableQty != 0)}

                                                                            {item.IsDeliverableAsPDF && <p className="text-muted fw-600 mb-2 pt-1 rounded-1 text-dark">
                                                                                Deliverables:
                                                                            </p>}
                                                                            {(item.SponsorshipStatusID == 1 && item.AvailableQty != 0) && <p className='text-danger mb-0'>(Click the image below to enlarge)</p>}
                                                                            {item.IsDeliverableAsPDF || item.SponsorshipStatusID == 2 ? <div
                                                                                style={{
                                                                                    flex: 1,
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    alignItems: 'center',
                                                                                }}>
                                                                                {item.SponsorshipStatusID != 2 ? this.checkFileExt(item.DeliverablePdfPath) == 'pdf' && (item.SponsorshipStatusID == 1 && item.AvailableQty != 0) ? <div
                                                                                    onClick={() => item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? this.openPdf(DOC_BASE_URL + item.DeliverablePdfPath) : null}
                                                                                    id="pdf-container"
                                                                                    ref={(el) => (this.pdfRefs[i] = el)}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        height: "300px",       // keeps it scrollable inside card
                                                                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                                                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                                                                        background: '#f5f5f5'
                                                                                    }}
                                                                                ></div> : <img
                                                                                    onClick={() => item.SponsorshipStatusID == 2 || item.AvailableQty == 0 ? null : window.open(item.DeliverablePdfPath, "_blank", "noopener,noreferrer")}
                                                                                    src={item.SponsorshipStatusID == 2 || item.AvailableQty == 0 ? DOC_BASE_URL + '/document/Sponsorship/CommonDoc/Booked.jpg' : item.DeliverablePdfPath}
                                                                                    style={{ margin: '2px', cursor: 'pointer' }}
                                                                                    alt="Preview"
                                                                                    width="300"
                                                                                    height="300"
                                                                                /> :
                                                                                    <img
                                                                                        onClick={() => item.SponsorshipStatusID == 2 || item.AvailableQty == 0 ? null : window.open(item.DeliverablePdfPath, "_blank", "noopener,noreferrer")}
                                                                                        src={item.SponsorshipStatusID == 2 || item.AvailableQty == 0 ? DOC_BASE_URL + '/document/Sponsorship/CommonDoc/Booked.jpg' : item.DeliverablePdfPath}
                                                                                        style={{ margin: '2px', cursor: 'pointer' }}
                                                                                        alt="Preview"
                                                                                        width="300"
                                                                                        height="300"
                                                                                    />
                                                                                }
                                                                                {/* <img
                                                                                onClick={() => window.open(item, "_blank", "noopener,noreferrer")}
                                                                                src={item.DeliverablePdfPath}
                                                                                style={{ margin: '2px', cursor: 'pointer' }}
                                                                                alt="Preview"
                                                                                width="200"
                                                                                height="200"
                                                                            /> */}
                                                                                {/* <iframe src={item.DeliverablePdfPath} width="300rem" height="300"></iframe> */}

                                                                            </div> :
                                                                                <div>
                                                                                    <table className="table table-bordered tb-action du-table mt-2">
                                                                                        <thead>
                                                                                            <tr key={Math.random()}>
                                                                                                <th style={{ width: '50%' }}>Deliverables:</th>
                                                                                                <th></th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {
                                                                                                item.deliverablesList.length > 0 ?
                                                                                                    item.deliverablesList.map((sub, index) => (<tr key={Math.random()} >
                                                                                                        <td>{sub.DeliverableName}</td>
                                                                                                        {item.IsDeliverableCommonPdf ?
                                                                                                            index == 0 ? <td rowSpan={item.deliverablesList.length}>{
                                                                                                                this.checkFileExt(item.DeliverableCommonPdfPath) == 'pdf' && (item.SponsorshipStatusID == 1 && item.AvailableQty != 0) ? <div
                                                                                                                    onClick={() => item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? this.openPdf(DOC_BASE_URL + item.DeliverablePdfPath) : null}
                                                                                                                    id="pdf-container"
                                                                                                                    ref={(el) => (this.pdfRefs[i] = el)}
                                                                                                                    style={{
                                                                                                                        width: "100%",
                                                                                                                        height: "300px",       // keeps it scrollable inside card
                                                                                                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                                                                                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                                                                                                        background: '#f5f5f5'
                                                                                                                    }}
                                                                                                                ></div> : <img
                                                                                                                    onClick={() => item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? window.open(item, "_blank", "noopener,noreferrer") : null}
                                                                                                                    src={item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? item.DeliverableCommonPdfPath : DOC_BASE_URL + '/document/Sponsorship/CommonDoc/Booked.jpg'}
                                                                                                                    style={{ margin: '2px', cursor: 'pointer' }}
                                                                                                                    alt="Preview"
                                                                                                                    width="200"
                                                                                                                    height="200"
                                                                                                                />}</td> : <></> :
                                                                                                            <td >{sub.DeliverablePDFDoc != '' && sub.DeliverablePDFDoc != null && <div style={{
                                                                                                                border: '1px solid #ced4da',
                                                                                                                padding: '10px',
                                                                                                                display: 'inline-flex',
                                                                                                                alignItems: 'center',
                                                                                                                // marginTop: '10px'
                                                                                                            }}>
                                                                                                                <a
                                                                                                                    href={item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ? DOC_BASE_URL + sub.DeliverablePDFDoc : DOC_BASE_URL + '/document/Sponsorship/CommonDoc/Booked.jpg'}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                >
                                                                                                                    <span style={{ marginRight: '10px' }}
                                                                                                                    >
                                                                                                                        {/* {passportImage} */}{this.getDocName(sub.DeliverablePDFDoc)}
                                                                                                                    </span>
                                                                                                                </a>
                                                                                                            </div>}</td>}
                                                                                                    </tr>
                                                                                                    )) : <><tr><td colSpan={2} className='text-center'>Record not found</td></tr></>
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>}
                                                                            {(item.SponsorshipStatusID == 1 && item.AvailableQty != 0) && <div className="form-row mt-3">
                                                                                <label className="d-flex px-3" >

                                                                                    <input type="checkbox" style={{ height: 20, marginTop: 2 }}
                                                                                        // name={data.ExhRegistrationNotesId}
                                                                                        value={item.isAgree}
                                                                                        checked={item.isAgree}
                                                                                        onClick={e => {
                                                                                            if (item.isAgree) {
                                                                                                item.isAgree = false
                                                                                                this.setState({ sponsorshipList: sponsorshipList })
                                                                                            } else {
                                                                                                this.setState({ isAgreePop: true, SSHdrId: item.SponsorshipHdrID })
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                    <div>
                                                                                        I have read the Guidelines for Sponsorship.<br></br>
                                                                                        <span className='text-primary'>{" "}Click here to view</span>
                                                                                    </div>
                                                                                </label>
                                                                            </div>}
                                                                            <div className="d-flex align-items-center gap-2 mt-auto">
                                                                                {item.SponsorshipStatusID == 1 && item.AvailableQty != 0 ?
                                                                                    <>
                                                                                        <button className="btn btn-aqua-border py-1-border w-100 view-btn m-0 mt-2"
                                                                                            onClick={() => item.isAgree ? this.setState({ interestedPop: true, SSHdrId: item.SponsorshipHdrID, type: item.SponsorshipTypeName, intererestMode: 1 }) :
                                                                                                this.setState({ isAgreePop: true, SSHdrId: item.SponsorshipHdrID, isForceOpen: true })}
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                textTransform: 'none !important'
                                                                                            }}
                                                                                        >
                                                                                            {"Submit Your Interest"}
                                                                                        </button>
                                                                                        <button className="btn btn-aqua-border py-1-border w-100 view-btn m-0 mt-2"
                                                                                            onClick={() => item.isAgree ? this.setState({ interestedPop: true, SSHdrId: item.SponsorshipHdrID, type: item.SponsorshipTypeName, intererestMode: 2 }) :
                                                                                                this.setState({ isAgreePop: true, SSHdrId: item.SponsorshipHdrID, isForceOpen: true })}
                                                                                            style={{
                                                                                                cursor: "pointer",
                                                                                                textTransform: 'none !important'
                                                                                            }}
                                                                                        >
                                                                                            Customization
                                                                                        </button>
                                                                                    </>
                                                                                    : <button className="btn btn-grey-border py-1-border w-100 view-btn m-0 mt-2"
                                                                                        disabled
                                                                                        style={{
                                                                                            border: 'solid 2px grey', cursor: 'default'
                                                                                        }}
                                                                                    >
                                                                                        Booked
                                                                                    </button>}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div>Record not found</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {console.log(sponsorshipList)}
                    <Modal isOpen={this.state.interestedPop} >
                        <div className="modal-dialog" style={{ marginTop: '-5%' }}>
                            <div className="modal-content confirm-logout">
                                <div class="modal-header text-right p-2">
                                    <h5 class="modal-title modal_title_text text-Primary">Exhibitor Details</h5>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="name" class="form-label fw-normal mb-0">Name<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="name" placeholder="" value={name} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="companyName" class="form-label fw-normal mb-0">Company Name<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="companyName" placeholder="" value={companyName} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="mobile" class="form-label fw-normal mb-0">Mobile<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="mobile" placeholder="" value={mobile} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="email" class="form-label fw-normal mb-0">Email<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="email" placeholder="" value={email} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="country" class="form-label fw-normal mb-0">Country<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="country" placeholder="" value={country} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="city" class="form-label fw-normal mb-0">City<span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="city" placeholder="" value={city} disabled />
                                        </div>
                                        <div class="col-md-12">
                                            <label for="additionalNote" class="form-label fw-normal mb-0">{this.state.intererestMode == 1 ? 'Additional notes' : 'Enter your customization requirements'}{this.state.intererestMode == 2 && <span class="text-danger">*</span>}</label>
                                            <textarea type="text" maxLength={2000} class="form-control" value={this.state.additionalNote} onChange={(e) => this.setState({ additionalNote: e.target.value })} onInput={e => this.maxLengthCheck(e, 2000)} />
                                        </div>
                                        <div class="col-md-12 text-danger mt-2">
                                            <p><strong>Any customization in the sponsorship package may incur additional costs and will be subject to availability.</strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer p-1">
                                    <div class="form-group text-right mod-fot">
                                        <button type="button" className="btn btn-aqua"
                                            onClick={() => {
                                                // this.togglePGCharges(2)
                                                this.insertInterested()
                                                // this.setState({ isForeignPop: false })
                                            }
                                            }
                                        >Submit</button>
                                        <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                            onClick={() => this.setState({
                                                interestedPop: false, SSHdrId: '',
                                                additionalNote: '', type: '', intererestMode: ''
                                            })}
                                        >Close</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </Modal >
                    <Modal isOpen={isAgreePop} onRequestClose={e => this.setState({ isAgreePop: !isAgreePop, isForceOpen: false })} >
                        <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                            <div className="modal-content responsive-width w-auto">
                                <div className="modal-header" style={{ padding: "10px 10px" }}>
                                    <h5 className="modal-title" id="termsandconLabel">
                                        <b>Guidelines for Sponsorship</b>
                                    </h5>
                                    <button style={{ fontSize: '16px' }}
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={e => this.setState({ isAgreePop: !isAgreePop, isForceOpen: false })}
                                    />
                                </div>

                                <div className="modal-body" style={{ height: 'calc(90vh - 200px)', overflowY: 'auto' }}>
                                    <div >
                                        <ol>
                                            {guidelines.length > 0 && guidelines.map(item => (
                                                <li><p>{item}</p></li>
                                            ))}
                                        </ol>
                                    </div>
                                </div>
                                <div className="form-row m-3 mt-2 mb-0 border-bottom">

                                    <div className="col-md-10">
                                        <p> I have read the Guidelines for Sponsorship.</p>
                                    </div>
                                    <div className="col-md-2">
                                        <button
                                            type="button"
                                            className="btn btn-gray"
                                            data-bs-dismiss="modal"
                                            style={{ padding: '4px 15px', float: 'right' }}
                                            onClick={e => {
                                                sponsorshipList.length > 0 && sponsorshipList.forEach((item => {
                                                    if (item.SponsorshipHdrID == this.state.SSHdrId) {
                                                        item.isAgree = !item.isAgree
                                                    }
                                                }))
                                                this.setState({
                                                    sponsorshipList: sponsorshipList, isAgreePop: false, interestedPop: isForceOpen ? true : false
                                                }, () => {
                                                    setTimeout(() => {
                                                        this.setState({ isForceOpen: false })
                                                    }, 100);
                                                })
                                            }}
                                        >
                                            Accept
                                        </button>
                                    </div>


                                </div>
                                {/* <div className="modal-footer" style={{ padding: 3 }}>
                    
                                                </div> */}
                            </div>
                        </div>

                    </Modal>
                </div>
            </>)
    }
}


export default withRouter(connect(null, { getSponsershipDetails_action, insertSponsorshipInterest_action, fill_action, deleteChapterDoc_action, deleteSSicertificate_action, deleteTMMAITAMMA_action })(Sponsorship));
